import styles from './styles.module.scss';
import Link from 'next/link';
import { useState, useEffect } from 'react';
import { useRouter } from "next/router";
import BtnCircleArrow from '/public/icons/btn-circle-arrow.svg';

export default function MangaContent({ data }) {
    const router = useRouter();
    const { slug } = router.query;
    const [currentIndex, setCurrentIndex] = useState(0);
    const images = data?.list || [];

    const handleNext = () => {
        if (currentIndex === images.length - 1) {
            // Last image
            setCurrentIndex(0);
            if (slug.endsWith('chap01')) {
                router.push('/manga-jp-chap02');
            } else if (slug.endsWith('chap02')) {
                router.push('/manga-jp-chap03');
            }
            // chap03 will be hidden, no need to handle here
        } else {
            // Not the last image
            setCurrentIndex(prev => Math.min(images.length - 1, prev + 1));
            window.scrollTo(0, 0);
        }
    };

    const getNextButtonText = () => {
        if (currentIndex === images.length - 1) {
            if (slug.endsWith('chap01') || slug.endsWith('chap02')) {
                return "Next";
            }
        }
        return null; // No text if not the last image or not chap01/chap02
    };

    const isNextButtonVisible = () => {
        if (currentIndex === images.length - 1) {
            if (slug.endsWith('chap03')) {
                return false;
            }
            if (slug.endsWith('chap01') || slug.endsWith('chap02')) {
                return true;
            }
        }
        return currentIndex < images.length -1;
    }

    useEffect(() => {
        //setCurrentIndex(10);
      }, []);

    return (
        <div className={styles.mangaContent} style={{ '--target-color': data?.theme || '#F3D682' }}>
            <button className="backpageBtn"></button>
            <div className={`container ${styles.wrap}`}>
                <h1>{data?.Title}</h1>
                {data?.subTitle && <div className={styles.subTitle}>
                    {data?.subTitle}
                </div>}
                {data?.description && <div className={styles.contnet} dangerouslySetInnerHTML={{ __html: data?.description, }} />}
                <div className={styles.imageContainer}>
                    <img 
                        src={images[currentIndex]?.image[0]?.url} 
                        alt={images[currentIndex]?.image[0]?.alternativeText} 
                    />

                    <button 
                        className={styles.prevBtn}
                        onClick={() => {
                            setCurrentIndex(prev => Math.max(0, prev - 1));
                            window.scrollTo(0, 0);
                        }}
                        style={{ display: currentIndex === 0 ? 'none' : 'block' }}
                    >
                        <BtnCircleArrow />
                    </button>

                    <button 
                        className={styles.nextBtn}
                        onClick={handleNext}
                        style={{ display: isNextButtonVisible() ? 'block' : 'none' }}
                    >
                        {getNextButtonText() || <BtnCircleArrow />}
                    </button>
                </div>
            </div>
        </div>
    );
}

